import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Button } from "../Button";
import { Image } from "../Image";

import "./styles.scss";

export const StepSelector = ({
  className,
  currentStep,
  onLeftClick,
  onRightClick,
  totalSteps,
  ...props
}) => {
  const leftArrowDisabled = currentStep === 1;
  const rightArrowDisabled = currentStep === totalSteps;

  return (
    <div className={createClassNameString(["apti-StepSelector", className])}>
      <Button
        className={leftArrowDisabled && "disabled"}
        onClick={leftArrowDisabled ? undefined : onLeftClick}
      >
        <Image src="icons/common/chevron-left-blue.svg" />
      </Button>
      <div className="apti-StepSelector--text">
        {currentStep} of {totalSteps}
      </div>
      <Button
        className={rightArrowDisabled && "disabled"}
        onClick={rightArrowDisabled ? undefined : onRightClick}
      >
        <Image src="icons/common/chevron-right-blue.svg" />
      </Button>
    </div>
  );
};

StepSelector.propTypes = {
  className: PropTypes.string,
  currentStep: PropTypes.string,
  totalSteps: PropTypes.string,
};

StepSelector.defaultProps = {
  className: undefined,
  currentStep: "",
  totalSteps: "",
};
